import React from 'react';
import styled from 'styled-components';

import Libro from './Libro';
import { libros } from '../data/libros';

import TituloFilete from './TituloFilete';

class Libros extends React.Component {
  render() {
    const Doble = styled.div`
      margin: 1em 0 1em 0;
      @media (min-width: 768px) {
        display: flex;
        justify-content: space-between;
        & > div {
          width: 45%;
        }
      }
    `;

    return (
      <div>
        <TituloFilete titulo="Libros" clave="Palabras de ahora para palabras de antes" />
        <Doble>
          <Libro libro={libros[1]} />
          <Libro libro={libros[2]} />
        </Doble>
        <Doble>
          <Libro libro={libros[3]} />
          <Libro libro={libros[4]} />
        </Doble>
      </div>
    );
  }
}

export default Libros;



// WEBPACK FOOTER //
// ./src/components/Libros.js